import * as yup from 'yup';
import addressSchema from '@features/workspace/schemas/address-schema';
import { CompanyTypeEnum } from '@utils/constants';
import { parsePhoneNumber } from 'libphonenumber-js';
import { ensureFirstPlus } from '@utils/formaters';

// @ts-ignore
const companyDetailsSchema = yup.object().shape({
  tradingAs: yup.string().max(100).label('Business name / trading as'),
  name: yup.string().max(100).label('Registered business name'),
  companyType: yup.number().required().label('Company type'),
  // TODO: Rule contains temporary fix for Credit API validation problem
  vatRegistrationNumber: yup
    .string()
    // https://secure.sarsefiling.co.za/vatvendorsearch/application/HELP.html
    // 10-digit number starting with 4 (SA VAT numbers)
    .matches(/^\d{10}$/, { message: 'Vat number must be 10 digits' })
    .transform((currentVal: any, originalVal: any) =>
      originalVal === '' ? null : currentVal
    )
    .nullable()
    .label('VAT number'),
  // TODO: Rule contains temporary fix for Credit API validation problem
  taxNumber: yup
    .string()
    .matches(/^\d{10}$/, { message: 'Tax number must be 10 digits' })
    .nullable()
    .transform((v, o) => (o === '' ? null : v))
    // @ts-ignore
    .when(['type'], (companyType, schema) => {
      if (
        [
          CompanyTypeEnum.SoleTrader,
          CompanyTypeEnum.ClosedCorporation,
          CompanyTypeEnum.Private,
        ].includes(companyType)
      ) {
        return schema.required();
      }

      return schema
        .transform((currentVal: any, originalVal: any) =>
          originalVal === '' ? null : currentVal
        )
        .nullable();
    })
    .label('Tax number'),
  // TODO: Rule contains temporary fix for Credit API validation problem
  registrationNumber: yup
    .string()
    // https://web.archive.org/web/20160714151904/http://www.cipro.gov.za:80/news_events/Notices.asp
    // First 4 digits denoting year of incorporation, next 6 digits are unique company reg number and last 2 digits are type of business
    .matches(/^(\d{4}\/\d{6}\/\d{2})$|^$/, {
      message: 'Registration number has wrong format. Expected: 9999/999999/99',
    })
    // @ts-ignore
    .when(['type'], (companyType, schema) => {
      if (
        [CompanyTypeEnum.ClosedCorporation, CompanyTypeEnum.Private].includes(
          companyType
        )
      ) {
        return schema.required();
      }

      return schema
        .transform((currentVal: any, originalVal: any) =>
          originalVal === '' ? null : currentVal
        )
        .nullable();
    })
    .label('Registration number'),
  businessRegistrationDate: yup
    .string()
    .when('type', {
      is: [0, 2, 3], // Type other than sole-trader
      then: yup.string().required(),
    })
    .label('Business Registration Date'),
  industry: yup.number().required().label('Industry'),
  businessBEEStatus: yup
    .string()
    .nullable()
    // .required()
    .label('BEE Status'),
  yearsOperational: yup.string().required().max(20).label('Business age'),
  annualTurnover: yup.string().required().max(20).label('Annual revenue'),
  phoneNumber: yup
    .string()
    .required()
    .max(16)
    .label('Business contact number')
    .test('is-phone', 'Invalid phone number', (value) => {
      try {
        const parsedPhoneNumber = parsePhoneNumber(ensureFirstPlus(value!));

        return parsedPhoneNumber?.isValid();
      } catch (error) {
        return false;
      }
    }),
  website: yup.string().max(100).label('Website'),
  address: addressSchema,
});

export default companyDetailsSchema;
